import gql from 'graphql-tag';

import { MarketingMaterialAssetDetails } from '../fragments/marketing-material-assets';

export const getAccountMarketingMaterialAssets = gql`
  query accountMarketingMaterialAssets(
    $marketingMaterialType: AccountMarketingMaterialEnum
    $searchQuery: String
  ) {
    me {
      id
      marketing_material_assets(
        slice: { limit: 999 }
        marketing_material_type: $marketingMaterialType
        search_query: $searchQuery
      ) {
        total
        records {
          ...MarketingMaterialAssetDetails
          created_at
          album_folders(slice: { limit: 999 }) {
            total
          }
        }
      }
    }
  }
  ${MarketingMaterialAssetDetails}
`;
